import { FC, ReactNode, useMemo } from 'react';
import { Workspace, WorkspacePermissionFlag } from '@robocorp/robocloud-internal-cds-sdk';
import { useCurrentWorkspace } from '~/queries';

interface Props {
  permission: WorkspacePermissionFlag;
  children: ReactNode;
}

/**
 * Renders child component if current user in current workspace have requested permissions
 */
export const CurrentWorkspaceRestriction: FC<Props> = ({ children, permission }) => {
  const { data: currentWorkspace } = useCurrentWorkspace();

  const workspacePermissions = currentWorkspace?.permissions;
  const hasPermission = useMemo(
    () => workspacePermissions?.includes(permission),
    [workspacePermissions, permission],
  );

  return hasPermission ? <>{children}</> : null;
};

interface WorkspacePermissionProps extends Props {
  workspace?: Workspace;
}

/**
 * Renders child component if current user in workspace have requested permissions
 */
export const WorkspaceRestriction: FC<WorkspacePermissionProps> = ({
  children,
  permission,
  workspace,
}) => {
  const workspacePermissions = workspace?.permissions;
  const hasPermission = useMemo(
    () => workspacePermissions?.includes(permission),
    [workspacePermissions, permission],
  );

  return hasPermission ? <>{children}</> : null;
};
